import React from 'react';
import "./SavedChats.css";
import PersonIcon from '@mui/icons-material/Person';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


const SavedChat = () => {
    const chats = [
        {
            id: 1,
            message: "Hello, could you provide details on available candidates for a Senior Backend Developer role?",
            timestamp: "2023-10-01 09:45 AM",
            replies: [
                { message: "Certainly! We have candidates experienced with Node.js, Java, and Python. Are there specific skills you need?", timestamp: "2023-10-01 09:46 AM" }
            ]
        },
        {
            id: 2,
            message: "Can you share the requisition process for a DevOps Engineer with AWS expertise?",
            timestamp: "2023-10-01 10:10 AM",
            replies: [
                { message: "Of course! Once we gather role specifics, we’ll filter candidates with AWS certification and DevOps experience.", timestamp: "2023-10-01 10:11 AM" }
            ]
        },
        {
            id: 3,
            message: "Are there any React Native developers available with 3+ years of experience?",
            timestamp: "2023-10-01 10:15 AM",
            replies: [
                { message: "Yes, we have several candidates skilled in React Native and mobile development. I can send profiles if needed.", timestamp: "2023-10-01 10:16 AM" }
            ]
        },
        {
            id: 4,
            message: "What’s the usual time frame to hire a Full Stack Developer specialized in MERN?",
            timestamp: "2023-10-01 10:30 AM",
            replies: [
                { message: "It typically takes 2-3 weeks, depending on the candidate availability and interview schedules.", timestamp: "2023-10-01 10:31 AM" }
            ]
        },
        {
            id: 5,
            message: "Could you list profiles for Data Scientists with experience in machine learning?",
            timestamp: "2023-10-01 10:45 AM",
            replies: [
                { message: "Yes, we have candidates proficient in ML, Python, and data analysis. I’ll share a list of available profiles shortly.", timestamp: "2023-10-01 10:46 AM" }
            ]
        },
        {
            id: 6,
            message: "I’m looking for a Frontend Developer with Angular expertise. Do you have candidates with Angular and TypeScript skills?",
            timestamp: "2023-10-01 11:00 AM",
            replies: [
                { message: "We do! We have candidates with solid experience in Angular and TypeScript. Let me know if you’d like to view some profiles.", timestamp: "2023-10-01 11:01 AM" }
            ]
        }
    ];

    return (
        <div className='settings-container settings-saved-chats'>
            <div className='settings-info-card settings-saved-chats-container'>
                <h1 className='settings-info-title'>Saved Chats</h1>
                <div className='settings-chat-list'>
                    {chats.map(chat => (
                        <div key={chat.id} className='settings-chat-item'>
                            <div className='settings-chat-msg'>
                                <PersonIcon style={{ marginRight: '8px', color: '#4caf50' }} />
                                <div style={{ flexGrow: 1 }}>
                                    <p className='settings-chat-message'>{chat.message}</p>
                                    <small className='settings-chat-timestamp'>{chat.timestamp}</small>
                                </div>
                                {chat.replies && chat.replies.map((reply, index) => (
                                    <div key={index} className='settings-chat-reply'>
                                        <div >
                                            <SupportAgentIcon style={{ marginRight: '8px', color: '#2196f3' }} />
                                            <div>
                                                <p className='settings-chat-message' style={{ color: '#90caf9' }}>{reply.message}</p>
                                                <small className='settings-chat-timestamp'>{reply.timestamp}</small>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <button className='settings-chat-chatBtn'>
                                Start Conversation <ArrowForwardIcon style={{ marginLeft: '4px' }} />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SavedChat;
